const GET_INITIATE_C_BAND_REPAIR = 'GET_INITIATE_C_BAND_REPAIR';
const INITIATE_C_BAND_REPAIR_SUCCESS = 'GET_INITIATE_C_BAND_REPAIR_SUCCESS';
const INITIATE_C_BAND_REPAIR_FAIL = 'GET_INITIATE_C_BAND_REPAIR_FAIL';
const C_BAND_AUTH_TOKEN_SUCCESS = 'C_BAND_AUTH_TOKEN_SUCCESS';
const C_BAND_AUTH_TOKEN_FAIL = 'C_BAND_AUTH_TOKEN_FAIL';
const C_BAND_LOAD_5G_ORDER_SUCCESS = 'C_BAND_LOAD_5G_ORDER_SUCCESS';
const C_BAND_LOAD_5G_ORDER_FAIL = 'C_BAND_LOAD_5G_ORDER_FAIL';
const C_BAND_CHECKELIGIBLITY_SUCCESS = 'C_BAND_CHECKELIGIBLITY_SUCCESS';
const C_BAND_CHECKELIGIBLITY_FAIL = 'C_BAND_CHECKELIGIBLITY_FAIL';
const GET_C_BAND_INSPECIO_TOCKEN_START = 'GET_C_BAND_INSPECIO_TOCKEN_START';
const GET_C_BAND_INSPECIO_TOCKEN = 'GET_C_BAND_INSPECIO_TOCKEN';
const GET_C_BAND_INSPECIO_TOCKEN_FAIL = 'GET_C_BAND_INSPECIO_TOCKEN_FAIL';
const SEND_C_BAND_INSPECIO_EMAIL_START = 'SEND_C_BAND_INSPECIO_EMAIL_START';
const SEND_C_BAND_INSPECIO_EMAIL = 'SEND_C_BAND_INSPECIO_EMAIL';
const SEND_C_BAND_INSPECIO_EMAIL_FAIL = 'SEND_C_BAND_INSPECIO_EMAIL_FAIL';
const SEND_C_BAND_INSPECIO_MESSAGE_START = 'SEND_C_BAND_INSPECIO_MESSAGE_START';
const SEND_C_BAND_INSPECIO_MESSAGE = 'SEND_C_BAND_INSPECIO_MESSAGE';
const SEND_C_BAND_INSPECIO_MESSAGE_FAIL = 'SEND_C_BAND_INSPECIO_MESSAGE_FAIL';
const INSPECIO_VALIDATEPIN_START = 'INSPECIO_VALIDATEPIN_START';
const INSPECIO_VALIDATEPIN_MESSAGE = 'INSPECIO_VALIDATEPIN_MESSAGE';
const INSPECIO_VALIDATEPIN_MESSAGE_FAIL = 'INSPECIO_VALIDATEPIN_MESSAGE_FAIL';
const GET_TECH_VALIDATE_CART = 'GET_TECH_VALIDATE_CART';
const TECH_VALIDATECART_SUCCESS = 'TECH_VALIDATECART_SUCCESS';
const TECH_VALIDATECART_FAIL = 'TECH_VALIDATECART_FAIL';
const GET_TECH_RETRIVE_CART = 'GET_TECH_RETRIVE_CART';
const TECH_RETRIVECART_SUCCESS = 'TECH_RETRIVECART_SUCCESS';
const TECH_RETRIVECART_FAIL = 'TECH_RETRIVECART_FAIL';
const GET_TECH_UPDATE_CART = 'GET_TECH_UPDATE_CART';
const TECH_UPDATECART_SUCCESS = 'TECH_UPDATECART_SUCCESS';
const TECH_UPDATECART_FAIL = 'TECH_UPDATECART_FAIL';
const GET_TECH_VALIDATE_ORDER = 'GET_TECH_VALIDATE_ORDER';
const TECH_VALIDATEORDER_SUCCESS = 'TECH_VALIDATEORDER_SUCCESS';
const TECH_VALIDATEORDER_FAIL = 'TECH_VALIDATEOREDR_FAIL';
const GET_TERMS_AND_CONDITIONS = 'GET_TERMS_AND_CONDITIONS';
const TECH_TERMAANDCONDITIONS_SUCCESS = 'TECH_ERMAANDCONDITIONS_SUCCESS';
const TECH_TERMAANDCONDITIONS_FAIL = 'TECH_TERMAANDCONDITIONS_FAIL';
const ASYNC_FETCH = 'ASYNC_FETCH';
const ASYNC_FETCH_SUCCESS = 'ASYNC_FETCH_SUCCESS';
const ERR_OCCURED = 'ERR_OCCURED';
const GET_DATA_SUCCESS = 'GET_DATA_SUCCESS';
const C_BAND_VALIDATE_PIN_SUCCESS = 'C_BAND_VALIDATE_PIN_SUCCESS';
const C_BAND_VALIDATE_PIN_FAIL = 'C_BAND_VALIDATE_PIN_FAIL';
const GET_C_BAND_VALIDATE_PIN = 'GET_C_BAND_VALIDATE_PIN';
const VERIFIED_PIN_CBAND = 'VERIFIED_PIN_CBAND';
const SUBMIT_ORDERS = 'SUBMIT_ORDERS';
const TECH_SUBMIT_ORDER_SUCCESS = 'TECH_SUBMIT_ORDER_SUCCESS';
const TECH_SUBMIT_ORDER_FAIL = 'TECH_SUBMIT_ORDER_FAIL';
const ORDER_CONFIRMATION = 'ORDER_CONFIRMATION';
const TECH_ORDER_CONFIRMATION_SUCCESS = 'TECH_ORDER_CONFIRMATION_SUCCESS';
const TECH_ORDER_CONFIRMATION_FAIL = 'TECH_ORDER_CONFIRMATION_FAIL';
const GET_ASSIGN_MTN = 'GET_ASSIGN_MTN';
const ASSIGN_MTN_SUCCESS = 'ASSIGN_MTN_SUCCESS';
const ASSIGN_MTN_FAIL = 'ASSIGN_MTN_FAIL';
const GET_RETREIVE_NPAN = 'GET_RETREIVE_NPAN';
const RETREIVE_NPAN_SUCCESS = 'RETREIVE_NPAN_SUCCESS';
const RETREIVE_NPAN_FAIL = 'RETREIVE_NPAN_FAIL';
const GET_CAPTURE_SIGNATURE = 'GET_CAPTURE_SIGNATURE';
const CAPTURE_SIGNATURE_SUCCESS = 'CAPTURE_SIGNATURE_SUCCESS';
const CAPTURE_SIGNATURE_FAIL = 'CAPTURE_SIGNATURE_FAIL';
const UPDATE_TECH_TOS_SIGNATURE = 'UPDATE_TECH_TOS_SIGNATURE';
const SEND_C_BAND_INSPECIO_SUBMIT_ORDER_SUCCESS = 'SEND_C_BAND_INSPECIO_SUBMIT_ORDER_SUCCESS';
const SEND_C_BAND_INSPECIO_SUBMIT_ORDER_PAGE_SUCCESS = 'SEND_C_BAND_INSPECIO_SUBMIT_ORDER_PAGE_SUCCESS';
const SEND_C_BAND_INSPECIO_SUBMIT_ORDER_PAGE_FAIL = 'SEND_C_BAND_INSPECIO_SUBMIT_ORDER_PAGE_FAIL';
const LANDING_PAGE_SELECTION = 'LANDING_PAGE_SELECTION';
const POST_SEND_LINK_ERROR_MESSAGE = 'POST_SEND_LINK_ERROR_MESSAGE';
const POST_SEND_LINK_ERROR_MESSAGE_SUCCESS = 'POST_SEND_LINK_ERROR_MESSAGE_SUCCESS';
const POST_SEND_LINK_ERROR_MESSAGE_FAIL = 'POST_SEND_LINK_ERROR_MESSAGE_FAIL';
const STATE_INTIALIZE = 'STATE_INTIALIZE';
const SEND_CREDIT_HOLD_ERR = 'SEND_CREDIT_HOLD_ERR';
const CREDIT_HOLD_ERROR_MESSAGE_SUCCESS = 'CREDIT_HOLD_ERROR_MESSAGE_SUCCESS';
const CREDIT_HOLD_ERROR_MESSAGE_FAIL = 'CREDIT_HOLD_ERROR_MESSAGE_FAIL';
const TECH_CBD_SEND_OTP_EMAIL = 'TECH_CBD_SEND_OTP_EMAIL';
const TECH_CBD_SEND_OTP_EMAIL_SUCCESS = 'TECH_CBD_SEND_OTP_EMAIL_SUCCESS';
const TECH_CBD_SEND_OTP_EMAIL_FAIL = 'TECH_CBD_SEND_OTP_EMAIL_FAIL';
const TECH_CBD_VALIDATE_OTP = 'TECH_CBD_VALIDATE_OTP';
const TECH_CBD_VALIDATE_OTP_SUCCESS = 'TECH_CBD_VALIDATE_OTP_SUCCESS';
const TECH_CBD_VALIDATE_OTP_FAIL = 'TECH_CBD_VALIDATE_OTP_FAIL';
const INSPECIO_TECH_CBD_VALIDATE_OTP = 'INSPECIO_TECH_CBD_VALIDATE_OTP';
const INSPECIO_TECH_CBD_VALIDATE_OTP_SUCCESS = 'INSPECIO_TECH_CBD_VALIDATE_OTP_SUCCESS';
const INSPECIO_TECH_CBD_VALIDATE_OTP_FAIL = 'INSPECIO_TECH_CBD_VALIDATE_OTP_FAIL';
const FETCH_TECH_CBAND_CREDIT_HOLD = 'FETCH_TECH_CBAND_CREDIT_HOLD';
const INSPECIO_TECH_CBD_GENERATE_OTP = 'INSPECIO_TECH_CBD_GENERATE_OTP';
const INSPECIO_TECH_CBD_GENERATE_OTP_SUCCESS = 'INSPECIO_TECH_CBD_GENERATE_OTP_SUCCESS';
const INSPECIO_TECH_CBD_GENERATE_OTP_FAIL = 'INSPECIO_TECH_CBD_GENERATE_OTP_FAIL';
const INSPECIO_TO_SHOW_FORGET_OPT = 'INSPECIO_TO_SHOW_FORGET_OPT';
const INSPECIO_TO_SHOW_FORGET_OPT_SUCCESS = 'INSPECIO_TO_SHOW_FORGET_OPT_SUCCESS';
const INSPECIO_TO_SHOW_FORGET_OPT_FAIL = 'INSPECIO_TO_SHOW_FORGET_OPT_FAIL';
const DECLINE_T_AND_C = 'DECLINE_T_AND_C';

export {
  GET_INITIATE_C_BAND_REPAIR,
  INITIATE_C_BAND_REPAIR_SUCCESS,
  INITIATE_C_BAND_REPAIR_FAIL,
  C_BAND_AUTH_TOKEN_SUCCESS,
  C_BAND_AUTH_TOKEN_FAIL,
  C_BAND_LOAD_5G_ORDER_SUCCESS,
  C_BAND_LOAD_5G_ORDER_FAIL,
  C_BAND_CHECKELIGIBLITY_SUCCESS,
  C_BAND_CHECKELIGIBLITY_FAIL,
  GET_C_BAND_INSPECIO_TOCKEN_START,
  GET_C_BAND_INSPECIO_TOCKEN,
  GET_C_BAND_INSPECIO_TOCKEN_FAIL,
  SEND_C_BAND_INSPECIO_EMAIL_START,
  SEND_C_BAND_INSPECIO_EMAIL,
  SEND_C_BAND_INSPECIO_EMAIL_FAIL,
  SEND_C_BAND_INSPECIO_MESSAGE_START,
  SEND_C_BAND_INSPECIO_MESSAGE,
  SEND_C_BAND_INSPECIO_MESSAGE_FAIL,
  INSPECIO_VALIDATEPIN_START,
  INSPECIO_VALIDATEPIN_MESSAGE,
  INSPECIO_VALIDATEPIN_MESSAGE_FAIL,
  ASYNC_FETCH,
  ASYNC_FETCH_SUCCESS,
  ERR_OCCURED,
  GET_DATA_SUCCESS,
  GET_TECH_VALIDATE_CART,
  TECH_VALIDATECART_SUCCESS,
  TECH_VALIDATECART_FAIL,
  GET_TECH_RETRIVE_CART,
  TECH_RETRIVECART_SUCCESS,
  TECH_RETRIVECART_FAIL,
  GET_TECH_UPDATE_CART,
  TECH_UPDATECART_SUCCESS,
  TECH_UPDATECART_FAIL,
  GET_TECH_VALIDATE_ORDER,
  TECH_VALIDATEORDER_SUCCESS,
  TECH_VALIDATEORDER_FAIL,
  GET_TERMS_AND_CONDITIONS,
  TECH_TERMAANDCONDITIONS_SUCCESS,
  TECH_TERMAANDCONDITIONS_FAIL,
  C_BAND_VALIDATE_PIN_SUCCESS,
  C_BAND_VALIDATE_PIN_FAIL,
  GET_C_BAND_VALIDATE_PIN,
  VERIFIED_PIN_CBAND,
  SUBMIT_ORDERS,
  TECH_SUBMIT_ORDER_SUCCESS,
  TECH_SUBMIT_ORDER_FAIL,
  ORDER_CONFIRMATION,
  TECH_ORDER_CONFIRMATION_SUCCESS,
  TECH_ORDER_CONFIRMATION_FAIL,
  GET_ASSIGN_MTN,
  ASSIGN_MTN_SUCCESS,
  ASSIGN_MTN_FAIL,
  GET_RETREIVE_NPAN,
  RETREIVE_NPAN_SUCCESS,
  RETREIVE_NPAN_FAIL,
  GET_CAPTURE_SIGNATURE,
  CAPTURE_SIGNATURE_FAIL,
  CAPTURE_SIGNATURE_SUCCESS,
  UPDATE_TECH_TOS_SIGNATURE,
  SEND_C_BAND_INSPECIO_SUBMIT_ORDER_SUCCESS,
  SEND_C_BAND_INSPECIO_SUBMIT_ORDER_PAGE_SUCCESS,
  SEND_C_BAND_INSPECIO_SUBMIT_ORDER_PAGE_FAIL,
  LANDING_PAGE_SELECTION,
  POST_SEND_LINK_ERROR_MESSAGE,
  POST_SEND_LINK_ERROR_MESSAGE_SUCCESS,
  POST_SEND_LINK_ERROR_MESSAGE_FAIL,
  STATE_INTIALIZE,
  SEND_CREDIT_HOLD_ERR,
  CREDIT_HOLD_ERROR_MESSAGE_SUCCESS,
  CREDIT_HOLD_ERROR_MESSAGE_FAIL,
  TECH_CBD_SEND_OTP_EMAIL,
  TECH_CBD_SEND_OTP_EMAIL_SUCCESS,
  TECH_CBD_SEND_OTP_EMAIL_FAIL,
  TECH_CBD_VALIDATE_OTP,
  TECH_CBD_VALIDATE_OTP_SUCCESS,
  TECH_CBD_VALIDATE_OTP_FAIL,
  INSPECIO_TECH_CBD_VALIDATE_OTP,
  INSPECIO_TECH_CBD_VALIDATE_OTP_SUCCESS,
  INSPECIO_TECH_CBD_VALIDATE_OTP_FAIL,
  INSPECIO_TECH_CBD_GENERATE_OTP,
  INSPECIO_TECH_CBD_GENERATE_OTP_SUCCESS,
  INSPECIO_TECH_CBD_GENERATE_OTP_FAIL,
  FETCH_TECH_CBAND_CREDIT_HOLD,
  INSPECIO_TO_SHOW_FORGET_OPT,
  INSPECIO_TO_SHOW_FORGET_OPT_SUCCESS,
  INSPECIO_TO_SHOW_FORGET_OPT_FAIL,
  DECLINE_T_AND_C,
};
